import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {AuthService} from '../auth.service';
import {getTokenData} from '../../utils/auth.utils';
import {startLoading, stopLoading} from '../../state/actions/loading.action';
import {Store} from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  // protected handlerErrorHelper;

  constructor(
    public auth: AuthService,
    private store: Store<{ loading: boolean }>
    // private handler: HandlerErrorHelpers,
  ) {
    // this.handlerErrorHelper = handler;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Authorization: `${getTokenData()?.token_type} ${getTokenData()?.access_token}`,
        'Access-Control-Allow-Origin': '*',
      },
    });

    console.log('request start');
    this.store.dispatch(startLoading());

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            console.log('request finish');
            this.store.dispatch(stopLoading());
            if (event.body.error) {
              throw event;
            }
          }
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            console.log('request finish');
            this.store.dispatch(stopLoading());
          }
        }
      )
    );
  }
}
